<template>
  <div class="table-column">
    <!-- Header cell -->
    <div
      v-tooltip="header.tooltip"
      class="header-cell"
      :class="{
        'text-center': header.center,
        'font-weight-bold': header.bold
      }"
      :style="{ width: header.width || 'auto' }"
      :title="header.tooltip"
    >
      {{ header.text }}
    </div>

    <!-- Data cells -->
    <div
      v-for="(row, rowIndex) in columnData"
      :key="rowIndex"
      class="data-cell"
      :class="{ 'text-center': header.center, 'font-bold': header.bold, 'nowrap': header.nowrap }"
      :style="{ width: header.width || 'auto' }"
      @click="$emit('rowClicked', rowIndex)"
    >
      <!-- Handle image type -->
      <img v-if="header.type === 'image' && row.value" :src="row.value" class="cell-image" />

      <!-- Regular cell content -->
      <template v-else-if="!header.label">{{ row.value }}</template>
      <v-chip small v-else label outlined :color="header.labelColor(row.value)">{{ row.value }}</v-chip>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    header: {
      type: Object,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
  },
  computed: {
    columnData() {
      // Extract all values for this column from the items
      return this.items.map(row => {
        // Find the item in the row that matches the column's value property
        return row.find(item => item.key === this.header.value) || { value: '' };
      });
    }
  }
}
</script>

<style scoped>
.table-column {
  display: inline-flex;
  flex-direction: column;
  vertical-align: top;
  position: sticky;
}

.header-cell {
  padding: 12px 8px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
  font-weight: 500;
  height: 50px;
}

.data-cell {
  padding: 12px 8px;
  border-bottom: 1px solid #eee;
  height: 50px;
  cursor: pointer;
}

.font-bold {
  font-weight: bold !important;
}

.text-center {
  text-align: center;
}

.cell-image {
  max-height: 40px;
  max-width: 40px;
  object-fit: contain;
}

.nowrap {
  white-space: nowrap;
}
</style>